import React from 'react'

const Footer = () => {
	return <footer className="Footer f-os-regular-18-14">Developed by Ollie Stevenson in React</footer>
}

export default Footer
